/*

    App Main Entry Point and background Worker

    Includes a few development helper for live reloading, which need to stay persistent in the bg of our app.

*/
let debug       = false;
myApp           = {}; //jshint ignore:line

// Main Entry Point
myApp.init = function () {
    if(debug) console.log('Initialize App');

    const Sentry = nw.require('@sentry/node');

    if(myApp.nativeUI !== undefined)
        return;

    // Log any issues with sentry
    if( nw.App.manifest.config.sentryID && !myApp.isSDKBuild) {
        if(debug) console.log('Enable Sentry Back-End Logging');
        Sentry.init({
            dsn: nw.App.manifest.config.sentryID
        });
    }

    // Dev Helper to connect our file watcher & autostart the devtools
    if (! /localhost/.test(window.location.href) ) {
        myApp.isSDKBuild  = (window.navigator.plugins.namedItem('Native Client') !== null);
        myApp.developmentMode(myApp.isSDKBuild);
    }

    // Set our global app reference
    nw.global.manifest = nw.App.manifest;
    // and working dir
    nw.global.workingDir = myApp.isSDKBuild ? './' : './';
    // Load our Application config
    require('./configHandler.js');
    myApp.configHandler.init();

    // Load our Application licenses
    require('./licenseHandler.js');
    myApp.licenseHandler.init();

    // Initialize our Native UI Elements
    require('./nativeUI.js');
    myApp.nativeUI.init();

    // Initialize our helpers
    require('./helper.js');
    myApp.helper.init();
};

// Helper Function, to make developers life easier
myApp.developmentMode = function(state) {
    const cliArguments = nw.App.argv;
    if(debug) console.log('CLI Arguments:', cliArguments );

    if(state) {
        if(debug) console.log('Running in Dev Mode!');
        nw.Window.get().showDevTools();

        // Check CLI Switches
        // if(cliArguments.includes('--editor')) {
        //     if(debug) console.log('Launching Editor!');
        // }

        const   fs          = nw.require('fs'),
                path        = nw.require('path'),
                chokidar    = nw.require('chokidar');

        // Simple file watcher for files from our node bg
        fs.watch('./resources/js/node', function() {
            if(debug) console.log('Reload App for Node File Change!!');

            // First make sure we remove our nativeUI elements
            // if things like the tray aren't properly removed before reloading our app
            // they wont be re-initialized correctly (Things like the tray remain, but arent usable anymore).
            if(myApp.nativeUI)
                myApp.nativeUI.remove();

            // Reload our chrome runtime to reload our scripts
            chrome.runtime.reload();
        });



        // Additional File Watcher for our html views,
        // as they don't need a full app restart its enough to reload their corresponding window
        const viewWatcher = chokidar.watch('./resources/views', {
            ignored: /[\/\\]\./, persistent: true
        });

        viewWatcher.on('change', function (file, stats) {
            const nFile = path.normalize( '/' + file );

            if(debug) {
                console.log('Reload File', file, stats);
                console.log('Normalized Path', nFile);
            }

            // Get a List of our opened Windows
            const appWindows  = chrome.app.window.getAll();

            appWindows.forEach( function (item, index) {
                const nwWindow    = nw.Window.get(appWindows[index].contentWindow);
                const location    = path.normalize( nwWindow.window.location.pathname );

                if(debug) console.log('Normalized Location',  location );

                if( location === nFile ) {
                    if(debug) console.log('Reload Window', nwWindow);

                    // reload our page with a mini delay to give our browser time to load, if we make sudden changes
                    // otherwise it could happen that our window location is still empty and therefore our window looses the connection to its actual page
                    setTimeout( function () {
                        nwWindow.window.location.reload();
                    }, 500);
                }
            });

        });
    }
    else if(debug) console.log('Running in Production Mode!');
};


// Init our Worker, once the dom is ready
document.addEventListener('DOMContentLoaded', function() {

    if(typeof nw === "undefined") {
        window.location.replace('./resources/views/index.html');
    }
    else
        myApp.init();

});
